<template>
    <rkm-row>
        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.gestante"
                label="Gestante"
                :disabled="data.model.cidadao.sexoId != this.enums.sexo.FEMININO || this.calcularIdade() || data.model.recusaCadastro"
                @change="resetMaternidadeReferencia()"
            >
                <rkm-form-radio :value="null">Não se aplica</rkm-form-radio>
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="4">

            <rkm-form-input
                label="Qual é a maternidade de referência?"
                v-model="data.model.condicao.maternidadeReferencia"
                :disabled="!data.model.condicao.gestante || data.model.recusaCadastro"
                :validations="data.model.condicao.gestante == true ? validations.maternidadeReferencia : {}"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-select
                :options="data.form.peso"
                label="Peso"
                show-default-option
                text-field="descricao"
                v-model="data.model.condicao.pesoId"
                default-option-text="Selecione"
                value-field="id"
                :disabled="data.model.recusaCadastro"
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.fumante"
                label="Fumante"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.usaAlcool"
                label="Usa álcool"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.outrasDrogas"
                label="Outras drogas"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.hipertensao"
                label="Hipertensão"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.diabetes"
                label="Diabetes"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.avcDerrame"
                label="Teve AVC/Derrame"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.infarto"
                label="Teve infarto"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.hanseniase"
                label="Está com hanseníase"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.tuberculose"
                label="Está com tuberculose"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.cancer"
                label="Tem ou teve câncer"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-radio-group
                v-model="data.model.condicao.fibromialgia"
                label="Fibromialgia"
                :disabled="data.model.recusaCadastro"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="6">
            <rkm-area
                title="Internação nos últimos 12 meses"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.internacao"
                            label="Teve internação?"
                            @change="resetInternacaoMotivo()"
                            :disabled="data.model.recusaCadastro"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col cols="8">
                        <rkm-form-input
                            label="Motivo"
                            v-model="data.model.condicao.internacaoMotivo"
                            :disabled="!data.model.condicao.internacao || data.model.recusaCadastro"
                            :validations="data.model.condicao.internacao == true ? validations.internacaoMotivo : {}"
                            uppercase
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="6">
            <rkm-area
                title="Doença cardíaca/do coração"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.doencaCardiaca"
                            label="Tem?"
                            @change="resetDoencaCardiacaQuais()"
                            :disabled="data.model.recusaCadastro"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col cols="8">
                        <rkm-form-checkbox-group
                            :options="data.form.doencasCardiacas"
                            label="Quais doenças cardíacas?"
                            name="doencasCardiacas"
                            text-field="descricao"
                            v-model="data.model.condicao.doencaCardiacaQuais"
                            value-field="id"
                            :disabled="!data.model.condicao.doencaCardiaca || data.model.recusaCadastro"
                            :validations="data.model.condicao.doencaCardiaca == true ? validations.doencasCardiacas : {}"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="6">
            <rkm-area
                title="Problemas nos rins"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.problemasRins"
                            label="Tem ou teve?"
                            @change="resetProblemasRinsQuais()"
                            :disabled="data.model.recusaCadastro"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col cols="8">
                        <rkm-form-checkbox-group
                            :options="data.form.problemasRins"
                            label="Quais problemas?"
                            name="problemasRins"
                            text-field="descricao"
                            v-model="data.model.condicao.problemasRinsQuais"
                            value-field="id"
                            :disabled="!data.model.condicao.problemasRins || data.model.recusaCadastro"
                            :validations="data.model.condicao.problemasRins == true ? validations.problemasRins : {}"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="6">
            <rkm-area
                title="Doença respiratória/no pulmão"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.doencaRespiratoria"
                            label="Tem?"
                            @change="resetDoencaRespiratoriaQuais()"
                            :disabled="data.model.recusaCadastro"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col cols="8">
                        <rkm-form-checkbox-group
                            :options="data.form.doencasRespiratorias"
                            label="Quais doenças respiratórias?"
                            inline
                            name="doencasRespiratorias"
                            text-field="descricao"
                            v-model="data.model.condicao.doencaRespiratoriaQuais"
                            value-field="id"
                            :disabled="!data.model.condicao.doencaRespiratoria || data.model.recusaCadastro"
                            :validations="data.model.condicao.doencaRespiratoria == true ? validations.doencaRespiratoria : {}"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="6">
            <rkm-area
                title="Tratamento psiquiátrico ou teve internação por problema de saúde mental"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.tratamentoSaudeMental"
                            label="Fez ou faz?"
                            :disabled="data.model.recusaCadastro"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="3">
            <rkm-area
                title="Acamado"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.acamado"
                            label="Está acamado?"
                            :disabled="data.model.recusaCadastro"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="3">
            <rkm-area
                title="Domiciliado"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.domiciliado"
                            label="Está domiciliado?"
                            :disabled="data.model.recusaCadastro"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="6">
            <rkm-area
                title="Plantas medicinais"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.plantasMedicinais"
                            label="Usa plantas medicinais?"
                            @change="resetPlantasMedicinaisQuais()"
                            :disabled="data.model.recusaCadastro"

                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col cols="6">

                        <rkm-form-input
                            label="Quais"
                            v-model="data.model.condicao.plantasMedicinaisQuais"
                            :disabled="!data.model.condicao.plantasMedicinais || data.model.recusaCadastro"
                            :validations="data.model.condicao.plantasMedicinais == true ? validations.plantasMedicinaisQuais : {}"
                            uppercase
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="6">
            <rkm-area
                title="Práticas integrativas e complementares"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-radio-group
                            v-model="data.model.condicao.praticasIntegrativas"
                            label="Usa práticas?"
                            :disabled="data.model.recusaCadastro"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>

        <rkm-col cols="12">
            <rkm-area
                title="Outras condições de saúde"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-input
                            label="1 - Qual?"
                            v-model="data.model.condicao.outrasCondicoesPrimaria"
                            :validations="validations.outrasCondicoesPrimaria"
                            :disabled="data.model.recusaCadastro"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            label="2 - Qual?"
                            v-model="data.model.condicao.outrasCondicoesSecundaria"
                            :validations="validations.outrasCondicoesSecundaria"
                            :disabled="data.model.recusaCadastro"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            label="3 - Qual?"
                            v-model="data.model.condicao.outrasCondicoesTerciaria"
                            :validations="validations.outrasCondicoesTerciaria"
                            :disabled="data.model.recusaCadastro"
                            uppercase
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-col>
    </rkm-row>
</template>

<script>
//Moment
import moment from 'moment'

//Enums
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    props: {
        data: { type: Object, required: false, },
    },
    data: () => ({
        enums: {
            sexo
        },
    }),
    computed: {
        validations() {

            return {
                doencasCardiacas: {
                    required: true,
                },
                doencaRespiratoria: {
                    required: true,
                },
                problemasRins: {
                    required: true,
                },
                maternidadeReferencia: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                },
                internacaoMotivo: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                    required: this.data.model.condicao.internacao
                },
                plantasMedicinaisQuais: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                },
                outrasCondicoesPrimaria: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                },
                outrasCondicoesSecundaria: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                },
                outrasCondicoesTerciaria: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                },
            }
        },
    },
    methods: {
        calcularIdade() {
            const dataAtual = moment(this.data.form.dataAtual);
            const idade = dataAtual.diff(this.data.model.cidadao.dataNascimento, 'years');

            if (!this.data.model.condicao.gestante && idade < 9
                || !this.data.model.condicao.gestante &&  idade > 60) {

                this.data.model.condicao.gestante = null
                this.resetMaternidadeReferencia()

                return true;
            }

            return false;
        },
        resetMaternidadeReferencia() {

            if (!this.data.model.condicao.gestante) {
                this.data.model.condicao.maternidadeReferencia = null
            }
        },
        resetInternacaoMotivo() {

            if (!this.data.model.condicao.internacao) {
                this.data.model.condicao.internacaoMotivo = null
            }
        },
        resetDoencaCardiacaQuais() {

            if (!this.data.model.condicao.doencaCardiaca) {
                this.data.model.condicao.doencaCardiacaQuais = []
            }
        },
        resetProblemasRinsQuais() {

            if (!this.data.model.condicao.problemasRins) {
                this.data.model.condicao.problemasRinsQuais = []
            }
        },
        resetDoencaRespiratoriaQuais() {

            if (!this.data.model.condicao.doencaRespiratoria) {
                this.data.model.condicao.doencaRespiratoriaQuais = []
            }
        },
        resetPlantasMedicinaisQuais() {

            if (!this.data.model.condicao.plantasMedicinais) {
                this.data.model.condicao.plantasMedicinaisQuais = null
            }
        }
    }
}
</script>